import { deleteRequest, get, post, postfd, publicPost, put } from "../helpers/apihelpers";

export const CreateReminderService=async(data)=>{
    try {
        const result = await post(`api/reminder/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateReminderService=async(data,id)=>{
    try {
        const result = await put(`api/reminder/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadReminderFile=async(data)=>{
    try {
        const result = await postfd(`api/reminder/upload_file`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetReminderService=async(id,type)=>{
    try {
        const result = await get(`api/reminder/get/${id}?type=${type}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetReminderDetailService=async(id)=>{
    try {
        const result = await get(`api/reminder/get/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const DeleteReminderService=async(id)=>{
    try {
        const result = await deleteRequest(`api/reminder/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}